
function Observer() {
    this.handlers = [];  // Los handlers suscritos
}

Observer.prototype = {
    subscribe: function(fn) {
        // Evitar suscripciones duplicadas del mismo handler
        if (this.handlers.indexOf(fn) === -1) {
            this.handlers.push(fn);
        }
    },
    unsubscribe: function(fn) {
        this.handlers = this.handlers.filter(function(item) {
            return item !== fn;
        });
    },
    fire: function(o, thisObj) {
        var scope = thisObj || window;
        this.handlers.forEach(function(item) {
            item.call(scope, o);
        });
    },
    // Limpiar todos los handlers para liberar memoria
    cleanup: function() {
        this.handlers = [];
    }
}

export default Observer;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/Helpers/Observer.js